import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import { AlertaSimplesDialog } from '../alerta-simples';
import { AlertaConfirmDialog } from '../alerta-confirm';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as moment from 'moment';

@Component({
  selector: 'app-me-avaliacoes',
  templateUrl: './me-avaliacoes.component.html',
  styleUrls: ['./me-avaliacoes.component.css']
})
export class MeAvaliacoesComponent implements OnInit {
  existeAv: boolean = false;
  hideCL: boolean = false;
  arrAvaliacoes: any[] = [];
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog: MatDialog) { }

  ngOnInit() {
    //this.hideCL = true;
    //this.existeTreino = true;
    this.carregarTreinos();
  }

  goFichaTreino(idTreino: any): void {
    this.router.navigate(['me/fichatreino/' + idTreino]);
  }


  carregarTreinos(): void {
    this.hideCL = false;
    var gDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha;
    this.tmaService.listarAvaliacoes(gDados)
      .subscribe((qRes) => {
        console.log(qRes);
        this.hideCL = true;
        if (qRes['res'] == 'ok') {
          this.arrAvaliacoes = qRes['arrAvaliacoes'];
          if (this.arrAvaliacoes.length > 0) {
            this.arrAvaliacoes.forEach(element => {
              element.DataAvaliacao = moment(element.DataAvaliacao).format('DD/MM/YYYY');
              element.ck = false;
            });
            this.existeAv = true;
          }
          else {
            this.existeAv = false;
          }
        }
      })
  }

  changeCk(idAval: any, qDone: any) {
    this.arrAvaliacoes.find(x => x.Id == idAval).ck = qDone;
    console.log(this.arrAvaliacoes);
  }


  goComparar(): void {
    //verificar qty check
    if (this.tmaService.hcPremium) {
      //premium pode comparar
      var qtyC = 0;
      var armazenaIds = '';
      this.arrAvaliacoes.forEach(element => {
        if (element.ck) {
          qtyC++;
          armazenaIds += element.Id + '-';
        }
      });
      if (qtyC > 1) {
        if (qtyC <= 6) {
          //liberado
          armazenaIds = armazenaIds.slice(0, -1);
          this.router.navigate(['/me/evolucao/' + armazenaIds]);
        }
        else {
          //aviso maximo
          const erroQty = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { tituloAlerta: "Limite Atingido", textoAlerta: "É permitido comparar até 6 (seis) avaliações ao mesmo tempo. Desmarque algumas e tente novamente", iconAlerta: 'warning' }
          })
        }
      }
      else {
        //aviso minimo
        const erroQty = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: "Comparar Avaliações", textoAlerta: "Você deve selecionar pelo menos 2 (duas) avaliações para realizar uma comparação!", iconAlerta: 'warning' }
        })
      }
    }
    else {
      if(this.tmaService.hcWA && this.tmaService.hcSO == 'ios'){
        //deixamos apenas 2 avaliações
        if (qtyC > 1) {
          if (qtyC <= 2) {
            //liberado
            armazenaIds = armazenaIds.slice(0, -1);
            this.router.navigate(['/me/evolucao/' + armazenaIds]);
          }
          else {
            //aviso maximo
            const erroQty = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { tituloAlerta: "Limite Atingido", textoAlerta: "É permitido comparar até 2 (duas) avaliações ao mesmo tempo. Desmarque algumas e tente novamente", iconAlerta: 'warning' }
            })
          }
        }
        else {
          //aviso minimo
          const erroQty = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { tituloAlerta: "Comparar Avaliações", textoAlerta: "Você deve selecionar pelo menos 2 (duas) avaliações para realizar uma comparação!", iconAlerta: 'warning' }
          })
        }
      }
      else{
        const dialogRefConf = this.dialog.open(AlertaConfirmDialog, {
          width: '300px',
          data: { tituloAlerta: "Premium", textoAlerta: "Esta é uma funcionalidade exclusiva para usuários premium. Deseja saber mais sobre os benefícios?", textoCancel: "Não", textoConfirm: "SIM" }
        });
        dialogRefConf.afterClosed().subscribe(result => {
          if (result == true) {
            this.router.navigate(['/premium']);
          }
        });
      }
    }

  }
  goDetail(idAvaliacao: any): void {
    this.router.navigate(['/me/avaliacao/' + idAvaliacao]);
  }

  goPesquisar(){
    this.router.navigate(['/pesquisar']);
    
  }
  voltar() :void{
    this.router.navigate(['/home']);
    //this._location.back();
  }
}
